import Link from "next/link";

import { Button } from "@/components/ui/button";

interface Props {
  children?: React.ReactNode;
}

const Header = ({ children }: Props) => {
  return (
    <header
      className="sticky top-6 z-[10] backdrop-blur-md w-[95%] sm:w-[1024px] mt-5 mx-auto rounded-3xl print:hidden"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.024)" }}
    >
      <div className="p-6 sm:px-8">
        <div className="flex items-center justify-between gap-2">
          <Link
            prefetch={false}
            href="/"
            title="Pro Leilão | O melhor site de Leilão de Imóveis e Imóveis CAIXA do Brasil"
            className="no-underline text-inherit"
          >
            <div className="flex items-center justify-center gap-4">
              <img
                loading="eager"
                src="/small-icon.png"
                alt="Logo"
                height={40}
                width={40}
              />
              <p className="font-semibold">Pro Leilão</p>
            </div>
          </Link>
          {children}
        </div>
      </div>
    </header>
  );
};

const CTA = () => {
  return (
    <div className="flex items-center justify-between gap-2">
      <Button asChild variant="ghost" className="hidden sm:block">
        <a href="/#ferramentas">Ferramentas</a>
      </Button>
      <Button asChild variant="ghost" className="hidden sm:block">
        <a href="/#encontre-seu-imovel">Encontrar imóveis</a>
      </Button>
      <Button asChild variant="outline">
        <Link href="/sign-in/">Entrar</Link>
      </Button>
    </div>
  );
};

Header.Main = Header;
Header.CTA = CTA;

export { Header };
